/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { Paper } from '@material-ui/core';
import moment from 'moment';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';

import { MENU_WIDTH } from '../constants';
import { getHistory, getHistoryExport } from '../store/actions/history';
import FilterPanel from '../components/FilterPanel';
import Button from '@material-ui/core/Button';

const columns = [
  {
    id: 'patient',
    label: 'Patient',
    minWidth: 170,
    align: 'center',
  },
  {
    id: 'device',
    label: 'Monitor',
    minWidth: 170,
    align: 'center',
  },
  {
    id: 'started',
    label: 'Started Monitoring',
    minWidth: 170,
    format: (value) => moment(value).format('MMM D, h:mm A'),
    align: 'center',
  },
  {
    id: 'finished',
    label: 'Finished Monitoring',
    minWidth: 170,
    format: (value) => (value ? moment(value).format('MMM D, h:mm A') : 'N/A'),
    align: 'center',
  },
  {
    id: 'has_alerts',
    label: 'Has Alerts',
    minWidth: 70,
    // format: (value) => (value ? value : 'N/A'),
    align: 'center',
  },
  {
    id: 'has_pauses',
    label: 'Has Pauses',
    minWidth: 70,
    align: 'center',
  },
  {
    id: 'has_low_battery',
    label: 'Has Low Battery',
    minWidth: 70,
    align: 'center',
  },
];

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    paddingLeft: MENU_WIDTH,
    paddingTop: '6rem',
    height: '100%',
  },
  paper: {
    margin: '2em',
  },
  content: {
    flexGrow: 1,
    borderRadius: 4,
  },
  table: {
    width: '100%',
  },
  headerCell: {
    backgroundColor: '#526488',
    fontWeight: 'bold',
    textAlign: 'center',
    color: 'white',
  },
  top: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    margin: '2rem 2rem 0 2rem',
  },
  button: {
    color: 'white',
    backgroundColor: '#00d1b2',
    '&:hover': {
      backgroundColor: '#00bca0',
    },
  },
}));

const History = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const historyList = useSelector((state) => state.history.historyList);
  const historyCount = useSelector((state) => state.history.historyCount);
  const [displayList, setDisplayList] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const classes = useStyles();
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [patientValue, setPatientValue] = useState('');
  const [deviceValue, setDeviceValue] = useState('');  const [idsValue, setIdsValue] = useState([]);

  useEffect(() => {
    sessionStorage.removeItem('ids');
    sessionStorage.removeItem('device');
    dispatch(getHistory(page + 1, rowsPerPage));
  }, []);

  useEffect(() => {
    console.log('Original historyList:', historyList);
    setDisplayList([...historyList]
    .sort((a, b) => new Date(b.link_date) - new Date(a.link_date)) // Sort by start date
    .map((row) => {
        console.log('Original historyList:', row);
        return {
          id: row.id,
          patientId: row.patient_id,
          patient: row.patient_name,
          device: row.mac_address,
          started: row.link_date,
          finished: row.unlink_date,
          has_alerts: row.has_alert_history && row.has_alert_history.length === 0 ? 'N/A': 
          <Button className={classes.button} size="small" 
          variant="contained" 
          onClick={() => handleNavigation(row.patient_id, row.mac_address, row.has_alert_history, "alerts")}>Alerts</Button>,
          has_pauses: row.has_pause && row.has_pause.length === 0 ? 'N/A':
          <Button className={classes.button} size="small" 
          variant="contained" 
          onClick={() => handleNavigation(row.patient_id, row.mac_address, row.has_pause, "pauses")}>Pauses</Button>, 
          has_low_battery: row.has_low_battery && row.has_low_battery.length === 0 ? 'N/A':
          <Button className={classes.button} size="small" 
          variant="contained" 
          onClick={() => handleNavigation(row.patient_id, row.mac_address, row.has_low_battery, "batteries")}>Battery</Button>, 
        };
      }),
    );
  }, [historyList]);

  const handleChangePage = (_event, newPage) => {
    setPage(newPage);
    dispatch(getHistory(newPage + 1, rowsPerPage, startDate, endDate, patientValue, deviceValue));
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
    dispatch(getHistory(1, +event.target.value, startDate, endDate, patientValue, deviceValue));
  };

  const handleNavigation = (patientId, deviceId, ids, screen) => {
    sessionStorage.setItem('ids', ids);
    sessionStorage.setItem('device', deviceId);
    if (screen === "alerts"){    
      history.push(`./history/${patientId}`);
    }
    if (screen === "pauses"){
      history.push(`./history-pauses/${patientId}`);
    }
    if (screen === "batteries"){
      history.push(`./history-low-battery/${patientId}`);
    }  
  };

  const onFiltersChanged = (filters) => {
    setStartDate(filters.start);
    setEndDate(filters.end);
    setPatientValue(filters.patient);
    setDeviceValue(filters.device);
    dispatch(getHistory(page + 1, rowsPerPage, filters.start, filters.end, filters.patient, filters.device));
  };

  const handleExport = () => {
    getHistoryExport(patientValue, startDate, endDate, deviceValue);
  };

  return (
    <div className={classes.root}>
      <div className={classes.top}>
        <FilterPanel onChange={onFiltersChanged} handleExport={handleExport} />
      </div>
      <Paper className={classes.paper}>
        <TableContainer className={classes.content}>
          <Table stickyHeader aria-label="sticky table" className={classes.table}>
            <TableHead>
              <TableRow>
                {columns.map((column, index) => (
                  <TableCell
                    className={classes.headerCell}
                    // eslint-disable-next-line react/no-array-index-key
                    key={index}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {displayList.map((row, index) => {
                return (
                  // eslint-disable-next-line react/no-array-index-key
                  <TableRow className={classes.row} hover key={index}>
                    {columns.map((column) => {
                      const value = row[column.id];
                      return (
                        <TableCell key={column.id} align={column.align} className={classes.cell}>
                          {column.format ? column.format(value) : value}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={historyCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Paper>
    </div>
  );
};

export default History;
